"use client"

import { cn } from "@/lib/utils"

interface ChatBubbleProps {
  isOwnMessage: boolean
  children: React.ReactNode
  className?: string
  onTouchStart?: (e: React.TouchEvent) => void
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  showTail?: boolean
  isPending?: boolean
}

const TAIL_FILL_OWN = "white"
const TAIL_FILL_OTHER = "#262626"

export function ChatBubble({ isOwnMessage, children, className, onTouchStart, onClick, showTail = true, isPending = false }: ChatBubbleProps) {
  const bubbleClass = isOwnMessage
    ? "bg-white text-black rounded-br-[6px] border border-neutral-200 dark:border-transparent"
    : "bg-neutral-800 text-white rounded-bl-[6px]"

  return (
    <div
      className={cn(
        "relative inline-block max-w-full rounded-3xl px-4 py-2.5 min-w-0 select-none [webkit-touch-callout:none]",
        bubbleClass,
        isPending ? "opacity-70" : undefined,
        className
      )}
      onTouchStart={onTouchStart}
      onClick={onClick}
    >
      {showTail && (
        <svg
          width="12"
          height="16"
          viewBox="0 0 12 16"
          className={cn("absolute bottom-0", isOwnMessage ? "-right-[5px]" : "-left-[5px]")}
          style={isOwnMessage ? undefined : { transform: "scaleX(-1)" }}
          aria-hidden
        >
          <path
            d="M0 16C0 16 4 14 6 10C8 6 6 0 6 0H0V16Z"
            fill={isOwnMessage ? TAIL_FILL_OWN : TAIL_FILL_OTHER}
          />
        </svg>
      )}
      <div className="block max-w-full min-w-0 break-words">{children}</div>
    </div>
  )
}

